// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__TxShW","navigationList":"styles_navigationList__BS6MD","navItem":"styles_navItem__sPM2_","link":"styles_link__D6WoL"};